<template>
    <meta-leads-connection />
</template>

<style lang="scss">

</style>

<script>
import MetaLeadsConnection from '@/components/facebook/MetaLeadsConnection.vue';

export default {
  components: {
    MetaLeadsConnection
  }
}
</script>